export default "__VITE_PUBLIC_ASSET__63a3100b__"